<template lang="pug">
    model-data-table(
        no-data-text='Sin contratos.'
        no-search
        ref='table'
        remind-key='contract-list'
        v-bind='tableProps'
        @detail='submitDetail'
        @remove='submitRemove'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelDataTable } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import ContractModel from '@/models/HumanResource/HrContract'
    import ContractFilters from '@/views/HumanResource/HrContract/partials/HrContractFilters'
    import ContractHeaders from '@/views/HumanResource/HrContract/partials/HrContractHeaders'
    //
    export default {
        name: 'contract-list',
        components: {
            ModelDataTable,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            tableProps() {
                return {
                    filters: ContractFilters,
                    headers: ContractHeaders,
                    service: ContractModel,
                }
            }
        },
        data() {
            return {
                selected: null,
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(ContractModel, error.response.data))
            },

            /**
             *
             */
            refresh() {
                this.$refs.table.refresh()
            },

            /**
             * 
             */
            submitCreate() {
                this.$router.push({ name: 'contract-create' })
            },

            /**
             * 
             */
            submitDetail(event) {
                this.$router.push({ name: 'contract-update', params: { id: event.item.id } })
            },

            /**
             * 
             */
            submitRemove(event) {
                //
                this.setWarningSnackbar({
                    title: '¿Desea eliminar contrato?',
                    message: 'Una vez eliminado no se puede recuperar.',
                    confirm: 'eliminar',
                })
                //
                this.selected = event.item
            },

            /**
             * 
             */
            successRemove() {
                this.setSuccessSnackbar('Contrato eliminado exitosamente.')
            },

            /**
             *
             */
            toRemove() {
                this.selected.delete().then(this.successRemove).then(this.refresh).catch(this.error)
            },
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch(val) {
                    case 'eliminar': this.toRemove()
                }
            }
        },
        mounted() {
            this.setItemsTopBar([
                {
                    text: 'crear contrato',
                    icon: 'add_circle',
                    action: this.submitCreate,
                }
            ])
            this.setTitleTopBar('Contratos')
        },
    }
</script>